import { useEffect, useRef } from "react";
const PropertySlide = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.play().catch((error: any) => {
        console.warn("Autoplay failed:", error);
      });
    }
  }, []);

  return (
    // <div className="slider" id="slider">
    //   <div className="section">
    //     <div className="title-text">
    //       "BRINGING CARE TO
    //       <br />
    //       YOUR COMMUNITY -<br />
    //       YOUR TRUSTED
    //       <br />
    //       MANAGEMENT
    //       <br />
    //       SOLUTION!"
    //     </div>
    //     <div className="info-box">
    //       <div className="info-section">
    //         <h2 className="title-text">ABM PROPERTY MANAGEMENT, INC.</h2>
    //         <p className="description">
    //           Provides homeowners associations with full property management
    //           services for residential communities throughout Southern
    //           California. We believe in taking a proactive approach to property
    //           management by working closely with the communities we serve and by
    //           addressing problems quickly and efficiently while they are still
    //           small.
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="slider" id="slider">
      <video autoPlay muted loop playsInline>
        <source src="/assets/video/combined.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay-text">
      <div className="section">
        <div className="title-text">
          "BRINGING CARE TO
          <br />
          YOUR COMMUNITY -<br />
          YOUR TRUSTED
          <br />
          MANAGEMENT
          <br />
          SOLUTION!"
        </div>
      </div>
      </div>
      <div className="info-box">
          <div className="info-section">
            <h2 className="title-text">ABM PROPERTY MANAGEMENT, INC.</h2>
            <p className="description">
              Provides homeowners associations with full property management
              services for residential communities throughout Southern
              California. We believe in taking a proactive approach to property
              management by working closely with the communities we serve and by
              addressing problems quickly and efficiently while they are still
              small.
            </p>
          </div>
        </div>
    </div>
  );
};

export default PropertySlide;
